export const getTranslation = (
  key: string,
  translations: { [key: string]: any }[] = [],
  defaultValue: string,
): string => translations[0]?.[key] ?? defaultValue

export default getTranslation
